
import { Vector2, Vector3 } from 'three';
import WallMaterial from '../../materials/WallMaterial';
import WallDesktop from './WallDesktop';
import WallsManager from './WallsManager';

export default class WallsManagerDesktop extends WallsManager
{
  constructor()
  {
    super();

    this.MaterialKlass = WallMaterial;
  }

  start()
  {
    super.start('wall');
  }

  __setup_label(wall, lab)
  {
    let text_pivot =  wall.type === 'left' ? new Vector2(1, 0) : new Vector2(-1, 0);

    let text_position = new Vector3(
      wall.type === 'left' ? 18 : -18,
      32,
      wall.obj.position.z - 1
    );

    super.__setup_label(wall, lab, text_pivot, text_position);
  }

  __init_walls(wall_name, type, walls, amount, distance_from_center)
  {
    super.__init_walls({
      wall_name: wall_name,
      type: type,
      walls: walls,
      amount: amount,
      distance_from_center: distance_from_center,
      distance_between_walls: 10,
      background_names: ['glass'],
      light_names: ['light_left', 'light_right', 'light_up', 'light_bottom'],
      WallKlass: WallDesktop
    });
  }

  __set_wall_position(wall_obj, distance_from_center, z_position)
  {
    wall_obj.position.set(distance_from_center, 0, z_position);
  }

  __get_initial_x_or_y(wall_obj)
  {
    return wall_obj.position.x;
  }
}
